import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { QuestRoutine } from "@joonapp/web-shared"
import { JoonUIColor, Typography } from "@joonapp/web-shared"
import { useId } from "react"

import Tooltip from "../../../components/tooltip/Tooltip"
import { getRoutineIconAndText } from "../../../util/quests"

const RoutineIcon = ({ routine }: { routine: QuestRoutine }) => {
  const id = useId()
  const { icon, text } = getRoutineIconAndText(routine)

  return (
    <div data-tooltip-id={id}>
      <Tooltip id={id}>
        <Typography variant="bodySmall" color={JoonUIColor.text.inverted}>
          {text}
        </Typography>
      </Tooltip>
      <FontAwesomeIcon icon={icon} />
    </div>
  )
}

export default RoutineIcon
